import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// ---- Currency (base = GBP) ----
export const CURRENCIES = [
  { code: "GBP", symbol: "£", rate: 1, locale: "en-GB", label: "British Pound" },
  { code: "USD", symbol: "$", rate: 1.27, locale: "en-US", label: "US Dollar" },
  { code: "EUR", symbol: "€", rate: 1.17, locale: "de-DE", label: "Euro" },
  { code: "AED", symbol: "د.إ", rate: 4.66, locale: "ar-AE", label: "UAE Dirham" },
  { code: "INR", symbol: "₹", rate: 106, locale: "en-IN", label: "Indian Rupee" },
  { code: "AUD", symbol: "A$", rate: 1.92, locale: "en-AU", label: "Australian Dollar" },
  { code: "CAD", symbol: "C$", rate: 1.72, locale: "en-CA", label: "Canadian Dollar" },
  { code: "SGD", symbol: "S$", rate: 1.71, locale: "en-SG", label: "Singapore Dollar" },
  { code: "JPY", symbol: "¥", rate: 191, locale: "ja-JP", label: "Japanese Yen" },
];

let _cur = CURRENCIES[0];
export const setCurrency = (code) => { _cur = CURRENCIES.find((c) => c.code === code) || CURRENCIES[0]; };
export const getCurrency = () => _cur;
export const convert = (gbpAmount) => Math.round((gbpAmount || 0) * _cur.rate);

export const money = (gbpAmount) =>
  new Intl.NumberFormat(_cur.locale, { style: "currency", currency: _cur.code, maximumFractionDigits: 0 }).format((gbpAmount || 0) * _cur.rate);

export const airlineLogo = (code) => `https://pics.avs.io/120/120/${code}.png`;
export const durationLabel = (mins) => `${Math.floor(mins / 60)}h ${mins % 60}m`;
